import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { GlobalHelper } from '../utils/GlobalHelper';
import { ArchitectureActions } from './ArchitectureActions';
import { SidebarModule, HamburgerTab } from '../constants/Enums';
import { MessageBoxPayload, LockState } from '../stores/ViewSettingsStore';
import { Stats } from '../utils/Stats';

export class ViewSettingsActions {
    private static lockCount: number = 0;
    private static sidebarLockCount: number = 0;

    public static updateTooltipPositions(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.UPDATE_TOOLTIPS,
            value: null
        });
    }

    public static setDragMode(value: boolean): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_DRAG_MODE,
            value: value
        });
    }

    public static showBars(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TOGGLE_BARS,
            value: true
        });
    }

    public static hideBars(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TOGGLE_BARS,
            value: false
        });
    }

    public static triggerResize(): void {
        GlobalHelper.coreApp.viewer.resize();
        AppDispatcher.dispatch({
            actionType: ActionConstants.WINDOW_RESIZE,
            value: null
        });
    }

    public static showExtraButtons(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_EXTRABUTTONS,
            value: true
        });
    }

    public static hideExtraButtons(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_EXTRABUTTONS,
            value: false
        });
    }

    public static showNetworkError(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_NETWORK_ERROR,
            value: true
        });
    }

    public static hideNetworkError(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_NETWORK_ERROR,
            value: false
        });
    }

    public static triggerDownload(pMessage: MessageBoxPayload): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TRIGGER_DOWNLOAD,
            value: pMessage
        });
    }

    public static articleAdded(): void {
        ArchitectureActions.finishRoomMode();
        AppDispatcher.dispatch({
            actionType: ActionConstants.ARTICLE_ADDED,
            value: null
        });
    }

    public static closeMessage(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_MESSAGE,
            value: null
        });
    }

    public static showMessage(payload: MessageBoxPayload | null): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_MESSAGE,
            value: payload
        });
    }

    public static selectSubChoice(pGroup: string, pId: number): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TOGGLE_SUBCHOICE,
            value: {group: pGroup, id: pId}
        });
    }

    public static toggleSubChoice(pChoice: string | null): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.TOGGLE_CHOICEMENU,
            value: pChoice
        });
    }

    public static setScrollbar(targetClass: string): void {
        const foo: JQuery = jQuery(targetClass + '.scrollbar-wcf');
        foo.scrollbar({ ignoreOverlay: true, ignoreMobile: true });
    }

    public static changeSidebar(sidebar: SidebarModule): void {
        Stats.sendSidebar(sidebar);
        GlobalHelper.stopActiveTool();

        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SIDEBAR,
            value: sidebar
        });
    }

    public static changeHamburger(tab: HamburgerTab | null): void {
        GlobalHelper.stopActiveTool();
        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_HAMBURGER,
            value: tab
        });
    }

    public static changeShareTab(tab: string): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.CHANGE_SHARETAB,
            value: tab
        });
    }

    public static withSidebarLock<T>(callback: () => Promise<T>): Promise<T> {
        if (ViewSettingsActions.sidebarLockCount < 1) {
            ViewSettingsActions.sidebarLockCount = 1;
            ViewSettingsActions.lockSidebar(true);
        } else {
            ViewSettingsActions.sidebarLockCount++;
        }

        return callback().then((value: T): T => {
            if (--ViewSettingsActions.sidebarLockCount < 1) {
                ViewSettingsActions.lockSidebar(false);
            }
            return value;
        }).catch((error: Error): Promise<T> => {
            if (--ViewSettingsActions.sidebarLockCount < 1) {
                ViewSettingsActions.lockSidebar(false);
            }
            return Promise.reject<T>(error);
        });
    }

    public static async returnLater<T>(value: T, timeout: number): Promise<T> {
        return new Promise<T>((resolve, reject) => {window.setTimeout(() => { resolve(value); }, timeout); });
    }

    public static async withLock<T>(
        callback: () => Promise<T>,
        component: JSX.Element | null = null
    ): Promise<T> {
        if (ViewSettingsActions.lockCount < 0) {
            ViewSettingsActions.lockCount = 0;
            console.log(new Error('ViewSettingsActions.lockCount is < 0'));
        }

        if (ViewSettingsActions.lockCount < 1 || component != null) {
            ViewSettingsActions.lockAll(true, component);
        }
        ViewSettingsActions.lockCount++;

        try {
            return await callback();
        } finally {
            if (--ViewSettingsActions.lockCount < 1) {
                ViewSettingsActions.lockAll(false);
            }
        }
    }

    private static lockSidebar(locked: boolean): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.LOCK_SIDEBAR,
            value: locked
        });
    }

    private static lockAll(locked: boolean, component: JSX.Element | null = null, transparent: boolean = false): void {
        const lockState: LockState = locked === true ? (component == null ? LockState.ANIMATION : LockState.COMPONENT) : LockState.UNLOCKED;

        AppDispatcher.dispatch({
            actionType: ActionConstants.LOCK_ALL,
            value: {
                state: lockState,
                component: component,
                transparent: transparent
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ViewSettingsActions.ts